const getFileSize = (mb) => 1024 * 1024 * mb; // 1024 * 1024 bytes = 1024 kbytes = 1 megabytes

export default getFileSize;
